// extracted by mini-css-extract-plugin
export default {"border":"contact_border__hvRfR","bg":"contact_bg__5acR8"};